//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent, useStore, computed } from '@nuxtjs/composition-api'

export default defineComponent({
  middleware: ['auth', 'redirectUnauthorized'],
  setup() {
    const store = useStore()
    const currentModal = computed(() => store.getters['modals/current'])

    const isAppBarVisible = computed(() => store.getters['layout/isAppBarVisible'])

    return {
      currentModal,
      isAppBarVisible
    }
  }
})
